import { CountryNameToISOCode } from '@lyrahealth-inc/shared-app-logic/src/features/intl/constants'
import { GetCustomerCopyFunc } from '@lyrahealth-inc/shared-app-logic/src/models/customer/Customer'

export const spacex: GetCustomerCopyFunc = () => {
  // set of country ISO codes excluding Singapore and Ireland
  const countryISOCodesToHideWorkLifeServicesFor = new Set(
    Object.values(CountryNameToISOCode).filter(
      (isoCode) => isoCode !== CountryNameToISOCode.Singapore && isoCode !== CountryNameToISOCode.Ireland,
    ),
  )
  return {
    displaySessionLimit: false, // This is a deliberate choice on behalf of SpaceX even though they have session limits
    countryISOCodesToHideWorkLifeServicesFor: countryISOCodesToHideWorkLifeServicesFor as Set<Uppercase<string>>,
  }
}
